import { Record } from "immutable";

export type LocationType = {
  id: string | null;
  name: string | null;
  countryName: string | null;
  imageURL: string | null;
  latitude: number | null;
  longitude: number | null;
};

export type OptionalLocationType = Partial<LocationType>;

const defaultLocation: LocationType = {
  id: null,
  name: null,
  countryName: null,
  imageURL: null,
  latitude: null,
  longitude: null
};

export default class Location extends Record(defaultLocation) {}
